var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2547_641",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H21V21H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2547_641)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3568 4.1947L10.5006 0.124268L9.64429 4.1947C9.36263 5.53367 8.69752 6.76178 7.73002 7.72928C6.76251 8.69679 5.53441 9.36189 4.19544 9.64356L0.125 10.4998L4.19544 11.3561C5.53439 11.6378 6.7625 12.3029 7.73002 13.2704C8.69752 14.2379 9.36263 15.466 9.64429 16.805L10.5006 20.8754L11.3568 16.805C11.6385 15.466 12.3036 14.2379 13.2711 13.2704C14.2387 12.3029 15.4667 11.6378 16.8057 11.3561L20.8761 10.4998L16.8057 9.64356C15.4667 9.36189 14.2386 8.69679 13.2711 7.72928C12.3036 6.76178 11.6385 5.53367 11.3568 4.1947Z",
    fill: "url(#paint0_linear_2547_641)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2547_641",
    x1: 10.5006,
    y1: 0.124268,
    x2: 10.5006,
    y2: 20.8754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3C3C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star-icon.d326e11cfbd1cabed875586f2968a3e1.svg";
export { ForwardRef as ReactComponent };